import { render } from "./ubuntu_body_banner3.vue?vue&type=template&id=39b41438&scoped=true"
import script from "./ubuntu_body_banner3.vue?vue&type=script&lang=js"
export * from "./ubuntu_body_banner3.vue?vue&type=script&lang=js"

import "./ubuntu_body_banner3.vue?vue&type=style&index=0&id=39b41438&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b41438"]])

export default __exports__